import { useEffect, useState } from 'react';
import { Mic } from 'lucide-react';
import { DEMO_FRAME_CLASS, DEMO_ROOT_CLASS } from './onboardingLayout';

const PATIENT_1 = 'غرفة 3 ليلى يوسف، ألم 4 من 10، أعيد التقييم بعد ساعتين.';
const PATIENT_2 = 'غرفة 21 نور الدين، ضغط 95 على 60، نبض 88.';
const CHAR_MS = 40;
const PAUSE_MS = 2200;

export default function RecordingDemoAnimation() {
  const [patient1Text, setPatient1Text] = useState('');
  const [patient2Text, setPatient2Text] = useState('');
  const [patient2Interim, setPatient2Interim] = useState(false);
  const [isRecording, setIsRecording] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let timerId = null;

    const wait = (ms) =>
      new Promise((resolve) => {
        timerId = setTimeout(resolve, ms);
      });

    const typeText = async (text, onChar) => {
      for (let i = 1; i <= text.length; i += 1) {
        if (cancelled) return;
        onChar(text.slice(0, i));
        await wait(CHAR_MS);
      }
    };

    const runLoop = async () => {
      while (!cancelled) {
        setPatient1Text('');
        setPatient2Text('');
        setPatient2Interim(false);
        setIsRecording(false);
        await wait(400);
        if (cancelled) return;

        setIsRecording(true);

        await typeText(PATIENT_1, setPatient1Text);
        if (cancelled) return;

        await wait(280);
        if (cancelled) return;

        setPatient2Interim(true);
        await typeText(PATIENT_2, setPatient2Text);
        if (cancelled) return;

        setPatient2Interim(false);
        await wait(PAUSE_MS);
        if (cancelled) return;

        setIsRecording(false);
        await wait(500);
      }
    };

    runLoop();

    return () => {
      cancelled = true;
      if (timerId) clearTimeout(timerId);
    };
  }, []);

  const showTranscript = patient1Text || patient2Text;

  return (
    <div className={DEMO_ROOT_CLASS}>
      <div className={`${DEMO_FRAME_CLASS} mx-auto w-full max-w-[240px] rounded-xl bg-[#464E59] shadow-lg`}>
        <div className="absolute inset-x-0 top-0 bottom-14 flex items-center justify-center px-3 pt-2">
          {showTranscript ? (
            <p dir="auto" className="line-clamp-4 text-center text-[11px] leading-relaxed text-white sm:text-xs">
              {patient1Text}
              {patient2Text && (
                <>
                  <br />
                  <span className={patient2Interim ? 'italic text-white/50' : ''}>
                    {patient2Text}
                  </span>
                </>
              )}
            </p>
          ) : (
            <p className="text-[9px] text-white/40">Connecting…</p>
          )}
        </div>

        <p className="onboarding-hold-hint pointer-events-none absolute bottom-12 left-0 right-0 z-[1] px-2 text-center text-[9px] text-white/70 sm:text-[10px]">
          {isRecording ? 'Release to finish' : 'Hold to record'}
        </p>

        <div className="pointer-events-none absolute bottom-2 left-1/2 z-20 -translate-x-1/2">
          <div className="relative">
            {isRecording && (
              <div className="onboarding-pulse-ring-primary absolute -inset-0.5 rounded-full" />
            )}
            <div
              className={`relative flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white shadow-fab sm:h-11 sm:w-11 ${
                isRecording ? 'scale-95' : ''
              }`}
            >
              <Mic className="h-5 w-5 sm:h-6 sm:w-6" strokeWidth={2} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
